<template>
  <div class="Suggestor" :class="inline ? 'Suggestor__inline' : ''">
    <div class="field has-addons has-addons-right">
      <input type="text" class="input" v-model="query" v-if="!item" />
      <button
        class="button is-small"
        v-if="!item"
        :class="loading ? 'is-loading' : ''"
        @click="add"
        :disabled="!q"
      >
        <i class="fas fa-plus"></i>
      </button>
    </div>
    <div class="Suggestions" v-show="haystack.length > 0 && q && !item">
      <div class="tags">
        <span
          class="Suggestion tag is-light"
          v-for="s in haystack"
          @click="choose(s)"
          :key="s.id"
          >{{ s.name }}</span
        >
      </div>
    </div>
    <span
      v-if="item && current"
      class="Chosen tag"
      :class="[inline ? 'is-light' : 'is-primary', color]"
    >
      {{ current.name }}
      <span class="delete is-small" @click="choose(null)"></span
    ></span>
  </div>
</template>
<script>
import { types as t } from "../../store/actions/kv";
import { kvChangeKey } from "../../store/models/_helpers";
import { types as f } from "../../store/actions/flow";
import { flowTypes, FlowItem } from "../../util/flowNotifications";
import { KV_LIST_FRENCH } from "../../store/actions/kv";

export default {
  name: "KvSuggestor",
  props: {
    item: {
      required: true
    },
    type: {
      type: String,
      required: true
    },
    inline: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      query: "",
      current: null,
      loading: false,
      haystack: []
    };
  },
  methods: {
    choose(a) {
      this.query = "";
      if (!a) {
        this.$emit("update", null);
        this.current = null;
        return;
      }
      this.current = a;
      this.$emit("update", a.id);
    },
    async add() {
      this.loading = true;
      const newKv = await this.$store.dispatch(t.ADD_KV, {
        type: this.type,
        name: this.query.trim()
      });
      this.$emit("update", newKv.id);
      this.$root.$emit(kvChangeKey(this.type));
      this.$store.dispatch(
        f.ADD_FLOW_ITEM,
        FlowItem({
          type: flowTypes.F_INFO,
          message: `Vous avez ajouté "${this.query.trim()}" à "${
            KV_LIST_FRENCH[this.type]
          }"`
        })
      );
      this.query = "";
      this.loading = false;
    }
  },
  computed: {
    q() {
      return this.query.trim().toLowerCase();
    }
  },
  async mounted() {
    if (this.item) {
      this.current = await this.$store.dispatch(t.GET_KV_BY_ID, {
        type: this.type,
        id: this.item
      });
    }
  },
  watch: {
    async q(val) {
      if (!val) {
        this.haystack = [];
        return;
      }
      this.haystack = await this.$store.dispatch(t.SEARCH_KV, {
        type: this.type,
        query: val
      });
    },
    async item(val) {
      if (val)
        this.current = await this.$store.dispatch(t.GET_KV_BY_ID, {
          type: this.type,
          id: val
        });
    }
  }
};
</script>

<style lang="scss">
.Suggestor {
  position: relative;
  .field {
    margin: 0;
  }
}

.Suggestions {
  position: absolute;
  left: 0;
  bottom: 0;
  transform: translateY(100%);
  background: #d0d0d0;
  padding: 0.75em 0.75em 0.25em;
  border-radius: 0 0 3px 3px;
  box-shadow: 0 6px 10px -3px #00000066;
  width: 100%;
  z-index: 1;
}

.Suggestion {
  cursor: pointer;
  em {
    font-style: normal;
    font-weight: bold;
  }
}
</style>
